export default function generateClassName(name, sortedColumn, sortType) {
  let className = 'text-center align-middle text-muted px-1';
  if (sortedColumn === name) {
    className += sortType === 'asc' ? ' fas fa-sort-up' : ' fas fa-sort-down';
  }
  return className;
}
